module.exports = __webpack_public_path__ + "img/txn-failure.efc5afdd.svg";